<template>
  <div class="card-header dash-card-header row flex-shrink-0">
    <lambo-header-item  :dashdata="dashdata"
                        :kpi="getKpiByString('01. Quality of Pre-Owned Locator Occurrence')"
                        class="col-2" />

    <lambo-header-item  :dashdata="dashdata"
                        :kpi="getKpiByString('02. Personal Contact')"
                        class="col-2" />

    <lambo-header-item  :dashdata="dashdata"
                        :kpi="getKpiByString('03. Quality of Personal Contact')"
                        class="col-2" />

    <lambo-header-item  :dashdata="dashdata"
                        :kpi="getKpiByString('04. Appointment Making')"
                        class="col-2" />

    <lambo-header-item  :dashdata="dashdata"
                        :kpi="getKpiByString('05. Quality of Offer')"
                        class="col-2" />

    <lambo-header-item  :dashdata="dashdata"
                        :kpi="getCiKpi()"
                        class="col-2" />
  </div>
</template>

<script>
  import performanceitem from './PerformanceItem';
  import LamboHeaderItem from './LamboHeaderItem';
  import KpiMixin from '@/mixins/lambo/KpiMixin';
  
  export default {
    components: {
      performanceitem, 
      LamboHeaderItem
    },

    mixins: [ KpiMixin ],

    methods: {
      getCiKpi() {
        return this.getKpiByString('06. Competitor CI') ?? this.getKpiByString('06. Lamborghini CI');
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/../scss/lambo/variables.scss";

  .dash-card-header {
    height: 90px !important;
  }

</style>
